import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import { FaSearch, FaClock } from "react-icons/fa";

const CustomDataTable = ({
  ref,
  columns,
  data = [],
  enableSearch = false,
  search,
  setSearch,
  serverPagenation = false,
  conditionalRowStyles = [],
  paginationTotalRows,
  handleChangePage,
  handleRowsChange,
  onSelectedRowsChange = false,
  selectableRows,
  selectableRowDisabled,
  pagination = true,
  fixedHeaderScrollHeight = '59vh',
  clearSelectedRows,
  paginationDefaultPage,
  paginationPerPage
}) => {
  const customStyles = {
    table: {
      style: {
        tableLayout: 'fixed',
      },
    },
    rows: {
      style: {
        backgroundColor: "white",
        borderBottom: "1px solid #e5e7eb",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#f1f5f9",
        position: 'sticky',
        top: 0,
        zIndex: 1,
      },
    },
    headCells: {
      style: {
        textAlign: "left",
        paddingTop: "0.75rem",
        paddingBottom: "0.75rem",
        paddingLeft: "1rem",
        paddingRight: "1rem",
        fontSize: "0.875rem",
        fontWeight: "600",
        color: "black",
        backgroundColor: "#f1f5f9",
        borderBottom: "2px solid #e5e7eb",
      },
    },
    cells: {
      style: {
        fontSize: "0.875rem",
        overflow: "hidden",
        color: "gray-800",
        padding: "0.75rem 1rem",
      },
    },
    pagination: {
      style: {
        fontSize: "0.875rem",
        backgroundColor: "#f1f5f9",
        color: "black",
        borderTop: "1px solid #D1D5DB",
        overflow: "hidden",
        borderBottomLeftRadius: "8px",
        borderBottomRightRadius: "8px",
      },
    },
  };

  const handlePageChange = (page) => {
    handleChangePage(page - 1);
  };

  const handleRowsPerPage = (rowsPerPage) => {
    handleRowsChange(rowsPerPage);
  };

  return (
    <div className="">
      <div className="">
        {enableSearch && (
          <div className="relative flex w-1/2 sm:w-3/4 md:w-2/3 lg:w-1/2 xl:w-1/3">
            <input
              className='w-full pl-10 py-2 rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-cyan-800 focus:border-transparent'
              placeholder="Search by name"
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-slate-400" />
          </div>
        )}
      </div>
      <div className="rounded-lg border border-gray-200">
        <DataTable
          ref={ref}
          columns={columns}
          data={data}
          pagination={pagination}
          paginationServer={serverPagenation}
          striped
          highlightOnHover
          customStyles={customStyles}
          paginationTotalRows={paginationTotalRows}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPage}
          paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30, 35]}
          paginationDefaultPage={paginationDefaultPage}
          paginationPerPage={paginationPerPage}
          fixedHeader
          fixedHeaderScrollHeight={fixedHeaderScrollHeight}
          conditionalRowStyles={conditionalRowStyles && conditionalRowStyles}
          onSelectedRowsChange={selectableRows && onSelectedRowsChange}
          selectableRows={selectableRows}
          clearSelectedRows={clearSelectedRows}
          selectableRowDisabled={selectableRowDisabled}
        />
      </div>
    </div>
  );
};

CustomDataTable.defaultProps = {
  data: [],
};

export default CustomDataTable;
